<template>
  <div>
    <pc-navbar/>
    <div class="paySuccess bg_fff" v-if="orderData.order_token">
      <!-- <div class="paySuccess bg_fff" v-if="order_token"> -->

      <div class='head text_center' v-if="source==='cv'">
        <div class="title f_24 color_40">简历修改【{{orderData.display_plan}}】</div>
      </div>
      <div class='head text_center' v-else>
        <div class="iconfont iconwancheng color_red"></div>
        <div class="title f_24 color_40">购买成功，请完善以下信息</div>
      </div>

      <div class="formBox">
        <div class='list service' v-if="source==='cv'">
          <div class="title f_16 color_40">已选择导师服务：</div>
          <div class="text f_14 color_90">
            <p>【{{orderData.cv_lang_desc}}】【{{orderData.industry_desc}}】
              <span v-if="orderData.display_plan=='在职版'">【{{orderData.work_year_desc}}】</span>
            </p>
            <p>【{{orderData.urgency_desc}}】【{{orderData.change_profession_desc}}】</p>
          </div>
        </div>
        <!-- 是否购买简历优化 -->
        <template v-if="orderData.cv_optimization">
          <div class='list' v-if="(orderData.cv_lang=='cn_en' || orderData.cv_lang=='cn') && !(orderData.cn_cv && orderData.cn_cv.token)">
            <div class="title f_16 color_40"><span class='color_red'>*</span> 选择简历（中文）</div>
            <div class="pr">
              <el-select v-model="cv_id" placeholder="请选择" class="optionBlock">
                <el-option v-for="item in orderData.cn_cv_options" :key="item.value" :label="item.name" :value="item.value"
                  :style="{'width':'480px'}">
                </el-option>
              </el-select>
              <div class="pa" v-if="!orderData.cn_cv_options.length" @click="showTips('中文简历')"></div>
            </div>
          </div>
          <div class='list' v-if="(orderData.cv_lang=='cn_en' || orderData.cv_lang=='en') && !(orderData.en_cv && orderData.en_cv.token)">
            <div class="title f_16 color_40"><span class='color_red'>*</span> 选择简历（英文）</div>
            <div class="pr">
              <el-select v-model="cv2_id" placeholder="请选择" class="optionBlock">
                <el-option v-for="item in orderData.en_cv_options" :key="item.value" :label="item.name" :value="item.value"
                  :style="{'width':'480px'}">
                </el-option>
              </el-select>
              <div class="pa" v-if="!orderData.en_cv_options.length" @click="showTips('英文简历')"></div>
            </div>
          </div>
          <div class='list'>
            <div class="title f_16 color_40">所申请工作的招聘链接 URL（如有）</div>
            <el-input v-model="job_url" placeholder="https://example.com/job_id_2345/apply"></el-input>
          </div>
        </template>
        
        <div class='list'>
          <div class="title f_16 color_40"><span class='color_red'>*</span> 常用手机号</div>
          <div class="pleaseChoose optionBlock" @click="showBindTips=true" >{{phone || '请输入'}}</div>

        </div>
        <div class='list' v-if="orderData.cv_optimization">
          <div class="title f_16 color_40"><span class='color_red'>*</span> 希望咨询导师的具体问题 (不超过3个问题)</div>
          <textarea class="textarea f_14" v-model="question" rows="6" placeholder="如：我今年XX大学XX系硕士毕业，之前投递过XX、XX和XX的XX职位，效果不理想，希望可以了解一下：
        1. 简历上的3段实习经历是否不足？
        2. 对于课外活动的描述是否没有体现领导力？
        3. 技能方面填写CFA 1报考可以吗？我还会XX和XX是否能够放在简历上？"></textarea>
        </div>

        <div class='list'>
          <div class="title f_16 color_40"> 绑定微信公众号（用于接收反馈通知）</div>
          <div class='QRCode clearfix'>
            <!-- 去掉验证 -->
            <!-- <div class="QRCodeImgBox fl pr" v-if="qrCodeData.showQrCode">
              <img class="QRCodeImg" :src="qrCodeData.url" alt="">
              <p class="qrCodeTitle text_center f_14 color_60">公众号</p>
              <div class="QRCodeTips pa text_center" @click="getQrcode()" v-if="qrCodeData.checkSize<1">
                <div class="iconfont iconcuowu"></div>
                <div class="text f_12 color_40">扫码失败<br/>请刷新重试</div>
              </div>
              <div class="QRCodeTips pa text_center" v-if="qrCodeData.state">
                <div class="iconfont iconwancheng"></div>
                <div class="text f_12 color_40">已关注</div>
              </div>
            </div> -->
            <div class="QRCodeImgBox fl pr">
              <img class="QRCodeImg" src="https://files.wondercv.com/mentor_order20200721.png" alt="">
              <p class="qrCodeTitle text_center f_14 color_60">公众号</p>
              <!-- <div class="QRCodeTips pa text_center">
                <div class="iconfont iconwancheng"></div>
                <div class="text f_12 color_40">已关注</div>
              </div> -->
            </div>
            <div class="tips">
              <p>温馨提示：</p>
              <p>扫码关注公众号更及时收到反馈通知~</p>
              <p>&nbsp;</p>
              <!-- <p>若扫码后仍无法提交，请尝试取关公众号后</p>
              <p>重新扫码关注，或联系在线客服协助你解决</p> -->
            </div>

            <!--去掉小助手二维码-->
            <div class="QRCodeImgBox fl pr" v-if="false">
              <img class="QRCodeImg" :src="subscribeData.url" alt="">
              <p class="qrCodeTitle text_center f_14 color_60">小助手</p>
              <div class="QRCodeTips pa text_center" @click="checkBindSubscribe()" v-if="subscribeData.checkSize<1 && !subscribeData.showTipsState">
                <div class="iconfont iconcuowu"></div>
                <div class="text f_12 color_40">扫码失败<br/>请刷新重试</div>
              </div>
              <div class="QRCodeTips pa text_center" v-if="subscribeData.showTipsState">
                <div class="iconfont iconwancheng"></div>
                <div class="text f_12 color_40">已确认成功</div>
              </div>
            </div>
          </div>
        </div>
        <div class="tips color_40 f_12">（加 <span class='color_red'>*</span>号的为必填信息）</div>
        <!-- 保存按钮 -->
         <!-- && bindData.bind_wechat && bindData.subscribe -->
        <div class="submitButton f_18 color_fff text_center current" v-if="showSubmit" @click="orderSubmit()">提交</div>
        <div class="submitButton f_18 color_fff text_center" v-else>提交</div>

      </div>
      
    </div>
    <bindPhone v-if="showBindTips" @cancelBindForm='cancelBindForm' @success='successPhone'/>
  </div>
</template>
<script>
  import { uuid } from 'vue-uuid';
  import api from '@/api';
  import { mapGetters, mapActions } from 'vuex'
  import { routerTo, get_tUser } from '@/assets/js/util';
    import { cvMixin } from '@/assets/js/mixins'
  import { updateJWT } from '@/assets/js/jwt'
    
  // 绑定手机弹窗
  // import bindPhone from '@/components/alert/bindPhone';
  import bindPhone from '../orders/phone';
  import PcNavbar from '@/components/base/navbar';

  export default {
    name: 'paySuccess',
    layout: 'notTop',
    data() {
      return {
        isBingWechat: false,  // 是否已经绑定微信
        _c_t:'',
        bindData:{ // 用户绑定详情
          user: {
            phone: "",
          },
          bind_wechat: false,
          subscribe: false,
        },
        orderData:{}, //订单详情

        cv_id: '', //选择简历 (中文)
        cv2_id: '', //选择简历 (英文)
        job_url: '', //所申请工作的招聘链接 URL (如有)
        question: '', //希望咨询导师的具体问题 (不超过3个问题)

        showBindTips: false,//是否显示绑定手机号
        qrCodeQuery:{ // 获取二维码参数
          scene_str:'bind_' + uuid.v1(), //场景值 {扫码业务}+{身份} 扫码业务：login 扫码业务(string):login 例如login_动态的uuid
          account_type:'cv_account', //账户种类 hr_account 或 cv_account
          operation_type:'bind', //是	bind/login 目前只用bind逻辑	
          expire_seconds:60, //二维码有效期
        },
        qrCodeTimeoutName:null, // 微信登录轮训定时器
        qrCodeData:{ //二维码参数
          showQrCode:false,
          state:false,
          url:'',
          checkSize:57/3, // 轮训次数
        },

        getSubscribeTimeoutName:null, // 微信关注公众号轮训定时器
        subscribeData:{
          showTipsState:false,
          url:'',
          checkSize:57/3, // 轮训次数
        },
        phone:'',
      }
    },
    mixins: [ cvMixin ],
    created() {
      this.$store.dispatch('app/setNavbarAction', '简历修改');
      // 8a5a7647-aad5-481b-94d7-d6b2ebdfc872
      let { token = '' } = this.$route.params;
      let { source = '' } = this.$route.query;
      this._c_t = get_tUser().c_t || '';
      this.order_token = token;
      this.source = source;
      console.log(token)
      //检查是否登录
      if(!this._c_t){
        //未登录
        routerTo('/signin?type=login')
        return false;
      }
      //获取页面信息
      this.getOrderData();
      //获取用户绑定信息
      this.getUsersSettings();
      //获取二维码
      // this.getQrCodeUrl();
      
    },
    beforeDestroy(){
      //清除绑定微信定时器
      clearTimeout(this.qrCodeTimeoutName)
      //清除关注公众号
      clearInterval(this.getSubscribeTimeoutName)
    },
    methods: {
      //获取页面信息
      getOrderData() {
        api.mentorOrders.mentorOrdersEdit(this.order_token) .then(res => {
          // console.log(res)
          if (res.code === 1000) {
           /*  if (res.data.cv_selected) {
              //this.$router.push({path:`/service/task/${this.order_token}`})
            } else { */
              this.orderData = res.data;
              // 引导用户 添加简历的提示
              let {
                cv_lang,
                cn_cv_options,
                en_cv_options,
                phone,
                cv_optimization, //是否购买简历优化,是否需要选择简历
              } = res.data;

              if(cv_optimization){
                //不是双语，并且 没有相对应语言的简历
                if ((cv_lang !== 'cn_en' && !res.data[cv_lang + '_cv_options'].length)) {
                  this.showTips(cv_lang === 'cn' ? '中文简历' : '英文简历');
                }
                //是双语，并且 2种语言都没有简历
                if (cv_lang === 'cn_en' && !cn_cv_options.length && !en_cv_options.length) {
                  this.showTips('简历');
                }
                // 对应简历，默认选择
                if (cv_lang === 'cn_en' || cv_lang === 'cn') {
                  this.cv_id = cn_cv_options.length ? cn_cv_options[0].value : ''; //默认选择第一个选择简历 (中文)
                }
                if (cv_lang === 'cn_en' || cv_lang === 'en') {
                  this.cv2_id = en_cv_options.length ? en_cv_options[0].value : ''; //默认选择第一个选择简历 (英文)
                }
              }
              
              this.phone = phone || '';
              // 对应简历，只有一份，默认选择 --end
            
          } else {
            this.$message.error(res.message)
            setTimeout(() => {
              window.location.href = '/account/users?index=3'
            }, 1000);
          }
        })
        .catch(err => {

        })
      },
      //保存信息
      async orderSubmit() {
        let { orderData, cv_id, cv2_id, job_url, question, order_token, phone } = this;
        let { cv_lang, cv_optimization } = orderData;
        //购买简历优化再判断简历选中状态
        if(cv_optimization){
          if (!cv_id && (cv_lang == 'cn_en' || cv_lang == 'cn')) {
            this.$message.error('请选择简历（中文）')
            return false;
          }
          if (!cv2_id && (cv_lang == 'cn_en' || cv_lang == 'en')) {
            this.$message.error('请选择简历（英文）')
            return false;
          }
          if (!question) {
            this.$message.error('请填写咨询导师的具体问题')
            return false;
          }
        }
        
        
        if (!phone) {
          this.$message.error('请填写手机号')
          return false;
        }
        
        let data = {
          cv_id,
          cv2_id,
          job_url,
          question, //问题
          phone
        }
        await api.mentorOrders.putMentorOrdersUpdate(order_token, data)
          .then(res => {
            if (res.code === 1000) {
              routerTo(`/service/task/${this.order_token}`)
            } else {
              this.$message.error(res.message)
            }
          })
          .catch(err => {

          })
      },
      showTips(messageContent) {
        document.body.style.position = 'static'
        document.body.style.overflow = 'hidden'
        const alertData = {
          show: true,
          type: 'message',
          showCancelButton: true, // 是否显示取消按钮
          showConfirmButton: true, // 是否显示确定按钮
          cancelButtonText: '导入简历',
          cancelButtonClass: 'seccess',
          confirmButtonText: '新建简历',
          confirmButtonClass: '',
          messageTitle: '选择简历',
          messageContent: `<p>你当前没有${messageContent}，请新建或导入简历</p>`,
          cancel: (close) => {
            document.body.style.position = 'initial'
            document.body.style.overflow = 'initial'
            close && close();
            setTimeout(() => {
              this.showImport();
            }, 400);
          },
          confirm: (close) => {
            document.body.style.position = 'initial'
            document.body.style.overflow = 'initial'
            close && close();
            //新建简历
            window.location.href = '/cvs'
          },
          complete: ''
        };
        this.$store.dispatch('app/setAlertData', alertData);
      },
      //显示上传文件
      showImport() {
        const alertData = {
          show: true,
          type: 'import'
        };
        this.$store.dispatch('app/setAlertData', alertData);
      },

      //获取用户绑定信息
      async getUsersSettings(){
        api.account.getUsersSettings(this._c_t).then(res=>{
          if(res.code === 1000){
            this.bindData = res.data;
            let { bind_wechat, subscribe } = res.data;
            //没绑定微信，需要轮训去绑定微信
            if(!bind_wechat){
              this.qrCodeData.showQrCode = true;
              this.getQrcode();
              this.isBingWechat = false
            } else {
              this.isBingWechat = true
            }
            // if(!subscribe){
            //   this.subscribeData.showTipsState = true;
            // }
            this.subscribeData.url = 'https://files.wondercv.com/mentor_order20200721.png'
          }
        })
      },
      //【微信】获取二维码
      getQrcode(){
        //轮训倒计时
        this.qrCodeData.checkSize = 57/3;
        //清除定时器
        clearInterval(this.qrCodeTimeoutName);
        
        //获取二维码接口
        api.auth.getWechatsQrcode(this.qrCodeQuery).then(res=>{
          if(res.code === 1000){
            this.qrCodeData.url = res.data.url;
            //轮训倒计时
            this.qrCodeData.checkSize = 57/3;
            // 【微信】检测是否登录
            this.checkWechatLogin();
          }else{
            this.$message.error(res.message);
          }
        })
        
      },
      //【微信】检测是否扫码
      checkWechatLogin(){
        this.qrCodeTimeoutName = setInterval(() => {
          this.getWechatJwtverify();
          this.qrCodeData.checkSize = this.qrCodeData.checkSize-1;
          if(this.qrCodeData.checkSize<1){
            clearInterval(this.qrCodeTimeoutName)
            //重新设置新的uuid
            // this.qrCodeQuery.scene_str = 'bind_' + uuid.v1();
            //重新获取二维码
            // this.getQrcode();
          }
        }, 3000);
      },
      //【微信】验证是否扫码
      getWechatJwtverify(){
        let query = {
          scene_str: this.qrCodeQuery.scene_str,
          operation_type:'bind',
        }
        api.auth.getWechatsQrcodeResult(query).then(async res=>{
          if(res.code === 1000){
            this.$message({
              message: '微信绑定成功',
              type: 'success'
            });
            if (res.data && res.data.jwt) {
              updateJWT({
                jwt: res.data.jwt,
                jwt_timestamp: res.data.jwt_timestamp
              })
              setTimeout(() => {
                window.location.reload();
              }, 500)
            }
            this.qrCodeData.url = 'https://files.wondercv.com/mentor_order20200721.png'
            this.bindData.bind_wechat = true;
            this.qrCodeData.state = true;
            //重新设置新的uuid
            // this.qrCodeQuery.scene_str = 'bind_' + uuid.v1();
            //清除定时器
            clearInterval(this.qrCodeTimeoutName)

          }else if(res.code === 200101){
            //此微信已经绑定别的账户
            this.$message({
              message: res.message,
              type: 'error'
            });
            this.showBindErrorTips();
            //重新设置新的uuid
            this.qrCodeQuery.scene_str = 'bind_' + uuid.v1();
            //重新获取二维码
            this.getQrcode();
          }
        })
      },

      //关闭绑定手机号
      cancelBindForm(phone){
        // if(phone){
        //   this.bindData.user.phone = phone;
        // }
        this.showBindTips = false;
      },
      successPhone(flag,phone) {
        this.phone = phone;
      },

      showBindErrorTips(){
        const alertData = {
          ...this.alertData,
          messageTitle: '绑定失败',
          confirmButtonText: '联系客服',
          cancelButtonText: '取消',
          messageContent: `<p>该微信已另外注册过账号，如仍需绑定请联系在线客服</p>`,
          confirm: async close => {
            let udesk_container = document.querySelector('#udesk_btn a');
            if(udesk_container!=null){
              udesk_container.click();
            }
            close()
          },
          cancel: close => {
            close()
          },
        }
        this.setAlertData(alertData)
      },
      //检测用户是否绑定公众号
      checkBindSubscribe(){
        this.subscribeData.checkSize = 57/6;
        clearInterval(this.getSubscribeTimeoutName);

        this.getSubscribeTimeoutName = setInterval(() => {
          this.subscribeData.checkSize = this.subscribeData.checkSize-1;
          api.account.getUsersSettings(this._c_t).then(res=>{
            if(res.code === 1000){
              let { subscribe } = res.data;
              //关注公众号，停止
              if(subscribe){
                this.bindData.subscribe = true;
                this.subscribeData.showTipsState = true;
                clearInterval(this.getSubscribeTimeoutName)
                // this.qrCodeData.url = 'https://files.wondercv.com/mentor_order20200721.png'
              }
            }
          })
          if(this.subscribeData.checkSize<1){
            clearInterval(this.getSubscribeTimeoutName);
          }
        }, 3000);
      },
    },
    computed: {
      //计算页面必填项是否完成
      showSubmit() {
        let {
          cv_id,
          cv2_id,
          question,
          orderData,
          phone
        } = this;
        let { cv_lang, cv_optimization } = orderData;
        let cvState = false;
        //购买简历优化再判断简历选中状态
        if(cv_optimization){
          if (cv_lang == 'cn_en') {
            cvState = (cv_id != '' && cv2_id != '')
          } else if (cv_lang == 'cn') {
            //判断是否选择中文模板
            cvState = cv_id != ''
          } else {
            //判断是否选择英文模板
            cvState = cv2_id != ''
          }
          cvState = cvState && question.length
        }else{
          //如果没购买简历优化，直接通过
          cvState = true;
        }
        
        if (cvState && phone) {
          return true
        }
        return false;
      },
    },
    watch:{
      showSubmit:function(){
        if(!this.showSubmit){
          return false;
        }
        let { bind_wechat, subscribe } = this.bindData;
        //没绑定微信，需要轮训去绑定微信
        // if(!subscribe){
        //   //检测用户是否绑定公众号
        //   this.checkBindSubscribe();
        // }
      },
    },
    components: {
      PcNavbar,
      bindPhone
    },
  }
</script>
<style lang="scss" scoped>
  // 公共初始化样式
  @import '~/assets/css/public';
  @import './index.scss';
</style>
